module.exports = __webpack_public_path__ + "cf53e1e441a737f86a8f62e20c878211.jpg";